module.exports = __webpack_public_path__ + "static/img/theme_new.6561815.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/theme_new.png
// module id = bP7J
// module chunks = 0